module.exports = __webpack_public_path__ + "Roboto-Bold-webfont.375c4f3bd35840adee24.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Bold-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold-webfont.svg
// module chunks = styles